import { useState } from 'react';

import { Box, Flex, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import { AccessControl } from 'assets/assetsV1/iconComponents';

import { Divider } from 'uiToolkitV1/Divider';
import { Tab } from 'uiToolkitV1/Tabs';
import { TextBodyLarge, TextLabel } from 'uiToolkitV1/Typography';

import { CreateAccessTable } from './Tables/CreateAccessTable/CreateAccessTable';
import { UploadTable } from './Tables/InsightsDownloadTable/UploadTable';
import { ViewEditTable } from './Tables/ViewEditTable/ViewEditTable';

const ACCESS_CONTROL_TABS = [
  {
    name: 'Create Access',
    Comp: CreateAccessTable,
  },
  {
    name: 'View & Edit Access',
    Comp: ViewEditTable,
  },
  {
    name: 'Insights, downloads and upload',
    Comp: UploadTable,
  },
];

const AccessControlMatrix = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const onTabChangeHandler = (index) => {
    setTabIndex(index);
  };

  return (
    <Box padding="1rem">
      <Flex mb="1rem" justifyContent="space-between" alignItems="center">
        <AccessControl boxSize="24px" color="#666666" />
        <Box flexGrow={1} ml="8px">
          <TextBodyLarge style={{ fontWeight: '600' }}>Access control</TextBodyLarge>
          <TextLabel color="text.g2">Define access according to the user types</TextLabel>
        </Box>
      </Flex>
      <Divider />
      <Tabs padding={0} isLazy defaultIndex={0} index={tabIndex} onChange={onTabChangeHandler} p={0} mt="12px">
        <TabList p="0 !important">
          {ACCESS_CONTROL_TABS.map(({ name }) => (
            // @ts-ignore
            <Tab key={name}>{name}</Tab>
          ))}
        </TabList>

        <TabPanels>
          {ACCESS_CONTROL_TABS.map(({ name, Comp }) => (
            <TabPanel key={name} p={0} mt={name !== 'View & Edit Access' ? '20px' : '0px'}>
              <Comp />
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default AccessControlMatrix;
